module.exports = __webpack_public_path__ + "static/media/0325_IMG_LES_MURS_PAPIER_BRIQUE_BLANCHE.4dbfe98f.png";